import { PAGINATION_MAPPINGS } from '../constants/table.constants';

export const DOSSIER_ASSIGNED_RESOURCE = {
  key: 'DOSSIER_ASSIGNED_RESOURCE',
  table: {
    enableSelect: true,
    defaultSort: 'lastname',
    dataLocation: '_embedded.static',
    emptyMessage: 'Er zijn momenteel geen contacten toegewezen',
    disablePagination: true,
    fields: [
      { value: 'firstname', label: 'Voornaam', show: true, order: 0 },
      { value: 'lastname', label: 'Achternaam', show: true, order: 1 },
      { value: 'email', label: 'E-mail', show: true, order: 2 }
    ],
    dataTransform: (data) =>
      data?.map((i) => {
        return {
          ...i
        };
      }),
    pageMapping: PAGINATION_MAPPINGS.DEFAULT
  }
};
